<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ $t(`${namespace}.title`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-menu
        v-if="
          claims.costCenter['ROLE_PUT_COSTCENTER_ID'] ||
          claims.costCenter['ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES'] ||
          claims.costCenter['ROLE_DELETE_COSTCENTER_ID']
        "
        offset-y
        left
      >
        <v-btn class="btn--more_vertical mx-0" slot="activator" color="gray-6" flat icon>
          <v-icon>more_vertical</v-icon>
        </v-btn>

        <v-list class="dropdown-menu-actions__list">
          <v-list-tile
            v-if="claims.costCenter['ROLE_PUT_COSTCENTER_ID']"
            :to="{
              name: 'CostCenter',
              params: { type: 'editar', id: data.id }
            }"
          >
            <v-list-tile-title>
              {{ $t(`${namespace}.editCostCenter`) }}
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-if="claims.costCenter['ROLE_PUT_COSTCENTER_ID']"
            @click="handleTemporaryDisabled"
          >
            <v-list-tile-title>
              {{
                costCenterTemporaryDisabled
                  ? $t(`${namespace}.enableCostCenter`)
                  : $t(`${namespace}.disabledCostCenter`)
              }}
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-if="claims.costCenter['ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES']"
            @click="handleAddCostCenterToAllEmployees"
          >
            <v-list-tile-title>
              {{ $t(`${namespace}.addCostCenterToAllEmployees`) }}
            </v-list-tile-title>
          </v-list-tile>

          <v-divider v-if="claims.costCenter['ROLE_DELETE_COSTCENTER_ID'] && claims.costCenter['ROLE_PUT_COSTCENTER_ID_ADDTOALLEMPLOYEES']" />

          <v-list-tile
            v-if="claims.costCenter['ROLE_DELETE_COSTCENTER_ID']"
            @click="openSingleDeleteDialog"
          >
            {{ $t(`${namespace}.deleteCostCenter`) }}
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close(false)"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <SingleDeleteDialog
      :visible="singleDeleteDialog"
      :item="data"
      @close="closeSingleDeleteDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SingleDeleteDialog from 'components/costCenters/dialogs/SingleDeleteDialog'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    data: {
      type: Object,
      required: true
    }
  },
  components: {
    SingleDeleteDialog
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims,
      costCenterTemporaryDisabled: ({ globalDrawer }) => globalDrawer.costCenterTemporaryDisabled
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.costCenter.header',
      singleDeleteDialog: false,
      temporaryDisabledTemp: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show',
      setCostCenterTemporaryDisabled: 'globalDrawer/set'
    }),

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    async handleTemporaryDisabled () {
      try {
        const temporaryDisabled = !this.data.temporaryDisabled

        await this.$apiService.updateCostCenter({
          ...this.data,
          temporaryDisabled
        })

        this.showAlert({
          type: 'success',
          message: temporaryDisabled
            ? this.$t(`Components.CostCenterForm.disableCostCenterMonthSuccess`)
            : this.$t(`Components.CostCenterForm.enabledCostCenterMonthSuccess`)
        })

        this.setCostCenterTemporaryDisabled({
          costCenterTemporaryDisabled: temporaryDisabled
        })

        this.$emit('reload')
      } catch (err) {
        console.log('ERROR:', err)

        if (err.response.data && err.response.data.errors) {
          const key = Object.keys(err.response.data.errors)[0]
          let msg

          if (key === 'name') {
            msg = this.$t(`Components.CostCenterForm.costCenteRequiredMessage`)
            return this.showAlert({ type: 'error', message: msg })
          }

          if (key === 'companyId') {
            msg = this.$t(`Components.CostCenterForm.selectedACompany`)
            return this.showAlert({ type: 'error', message: msg })
          }

          this.showAlert({
            type: 'error',
            message: this.temporaryDisabled
              ? this.$t(`Components.CostCenterForm.enabledCostCenterMonthError`)
              : this.$t(`Components.CostCenterForm.disableCostCenterMonthError`)
          })
        }

        this.showAlert({
          type: 'error',
          message: this.temporaryDisabled
            ? this.$t(`Components.CostCenterForm.disableCostCenterMonthError`)
            : this.$t(`Components.CostCenterForm.enabledCostCenterMonthError`)
        })
      }
    },

    async handleAddCostCenterToAllEmployees () {
      try {
        await this.$apiService.addToAllEmployees(this.data.id)
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.addToAllEmployeesSuccess`)
        })
      } catch (err) {
        console.log('ERROR:', err)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.addToAllEmployeesError`)
        })
      }
    },

    openSingleDeleteDialog () {
      this.singleDeleteDialog = true
    },

    closeSingleDeleteDialog (reload) {
      this.singleDeleteDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
